import App from "@/App.vue";
import Vue from "vue";

/* Sentry */
import * as Integrations from "@sentry/integrations";
import * as Sentry from "@sentry/browser";

if (process.env.VUE_APP_SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_KEY,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  });
}

import router from "@/router";
import store from "@/store";

import "buefy/dist/buefy.css";
import Buefy from "buefy";

import VueAxios from "vue-axios";
import axios from "axios";

// Configure Icons
import { library } from "@fortawesome/fontawesome-svg-core";
// internal icons
import {
  faCheckCircle,
  faCheckSquare,
  faCogs,
  faCoins,
  faCreditCard,
  faExclamationTriangle,
  faPlayCircle,
  faSignOutAlt,
  faUniversity,
  faUser,
  faUserCircle
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faUser,
  faCoins,
  faCogs,
  faSignOutAlt,
  faUserCircle,
  faCheckSquare,
  faPlayCircle,
  faCreditCard,
  faUniversity,
  faCheckCircle,
  faExclamationTriangle
);
Vue.component("vue-fontawesome", FontAwesomeIcon);

// Setup the Bulma UI library
const buefyConfig = {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas"
};
Vue.use(Buefy, buefyConfig);

// Install the API library
Vue.use(VueAxios, axios);

// Install the progress manager
import VueProgressBar from "vue-progressbar";

Vue.use(VueProgressBar, {
  color: "rgb(246, 149, 129)",
  failedColor: "red",
  thickness: "4px"
});

import i18n from "@/i18n";

Vue.component("stream");

Vue.config.productionTip = false;

export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
